function mapGetOneUserProductsAuthorityImportData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListUserProductsAuthorityImportsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneUserProductsAuthorityImportData, mapGetListUserProductsAuthorityImportsData };
